import React, { useState } from 'react';
import InfoIcon from '../../../dist/icons/InfoIcon';
const AuthTexfield = ({name,dvalue="", type, label,fnc, children}) => {
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    const handleChange = (e) => {
        fnc(e.target.value);
        if(e.target.value.length <= 0){
            setError(true);
            setMessage('Ce champs ne doit pas être vide');
        }else{
            setError(false);
            setMessage(null);
        }
        if(type === 'email'){
            if(!e.target.value.match(re)){
                setError(true);
                setMessage('Entrer une adresse mail valide');
            }else{
                setError(false);
                setMessage(null);
            }
        }
    }
    return (
        <>
        <div className={`ipay-ui-auth__textfield ${(!error) ? '' : 'is--error'}`}>
            
            <input type={type} defaultValue={dvalue} name={name} onChange={handleChange} required />
            <label>{label}</label>
            <div className='ipay-ui-auth-textfield__info'>
                <InfoIcon/>            
            </div>
            <div className='ipay-ui-auth-textfield__tooltip'>
                {children}
            </div>
        </div>
        {
            (error) ? (
                <div className='ipay-ui-auth__textfield-error'>
                    <p>{message}</p>
                </div>
            ) : (null)
        }
       
        </>
        
    );
};

export default AuthTexfield;